import React, { Component } from 'react';
import './Filters.scss';
import { statuses } from '../../../config'
import Toggle from 'react-toggle'

class Filters extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    onChangeCheck (value, check) {
      this.props._filter(value, check)
    }

    render() {

        const filters = statuses.map((item, index) => {
          return (
            <div key={`filter${index}`} key={index} className="m-b-md row">
              <div className='col-xs-6 col-sm-6'>
                {item.label}
              </div>
              <div className={`col-xs-6 col-sm-6 text-right ${item.value}`}>
                <Toggle checked={this.props.filter.includes(item.value)} onChange={this.onChangeCheck.bind(this, item.value, this.props.filter.includes(item.value))} />
              </div>
            </div>
          )
        })

        return (
            <div className='filters-comp'>
                {filters}
            </div>
        )
    }
}

export default Filters



// WEBPACK FOOTER //
// ./src/views/components/Filters/index.js